import React from "react";
import { Button, Icon } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

export interface Props {
	loading: boolean;
	page: () => void;
	hasMore: boolean;
	pageType: string;
}

function PaginationButton({ loading, page, hasMore, pageType }: Props) {
	const { t } = useTranslation();
	return (
		<>
			{hasMore ? (
				<Button
					className={`btn-tertiary btn-lg ${pageType}_page-btn page-btn page-btn--lg pagination-spinner mt-4`}
					onClick={page}
					label={!loading && t("main.labels.loadMore")}
					icon={loading && <Icon type="spinner-third" spin />}
				/>
			) : null}
		</>
	);
}

export default PaginationButton;
